/*
 * @overview: SDK参数配置文件
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-29 16:05:41
 */

export class Options {
  constructor({ use = true, key = "", domain = "" } = {}) {
    this.domain = domain; // api地址
    this.use = use; // 是否开启监控
    this.key = key; // 项目唯一key
  }
  async bindOption(options = {}) {
    const { use, key, domain } = options;
    this.domain = domain;
    this.use = use;
    this.key = key;
  }
}

/**
 * 绑定配置参数
 */
const options = new Options();
export const initOptions = (paramsOption = {}) => {
  return new Promise((resolve) => {
    options.bindOption(paramsOption);
    resolve();
  });
};

export { options };
